import Service from "./Service";
const baseurl = '/api/historia-edad-antecedente';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    showByAc(id) {
        return Service.get(`${baseurl}/show-by-ac/${id}`);
    },
}